import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sun } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import BrandLogo from "@/components/BrandLogo";

export default function MagicVerify() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = new URLSearchParams(window.location.search).get("token");
    const run = async () => {
      if (!token) { setError("This sign-in link is missing its token."); return; }
      try {
        const res = await api.post("/auth/magic/verify", { token });
        setUser(res.data.user);
        navigate("/dashboard");
      } catch (e) {
        setError(e.response?.data?.detail || "This sign-in link is invalid or has expired.");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#000000] text-white">
      <div className="flex flex-col items-center gap-4 text-center px-6" data-testid="magic-verify">
        <BrandLogo variant="light" size={34} />
        {error ? (
          <>
            <div className="text-sm text-rose-400 max-w-xs" data-testid="magic-verify-error">{error}</div>
            <button onClick={() => navigate("/login")} className="text-sm text-[#F4C400] underline underline-offset-2">
              Back to sign in
            </button>
          </>
        ) : (
          <div className="flex items-center gap-2 text-slate-400 text-sm">
            <Sun className="w-5 h-5 animate-spin text-[#F4C400]" /> Signing you in…
          </div>
        )}
      </div>
    </div>
  );
}
